import { api } from '../utils/api';

// E-shop CRUD operations
export const createEshop = (eshopData) => {
    return api.post('/api/eshops', eshopData);
};

export const updateEshop = (id, eshopData) => {
    return api.put(`/api/eshops/${id}`, eshopData);
};

export const getEshop = (eshopId) => {
    return api.get(`/api/eshops/${eshopId}`);
};

export const testEshopConnection = (eshopId, config) => {
    return api.post(`/api/eshops/${eshopId}/test`, { config });
};

export const testProductLoading = (eshopId, config) => {
    return api.post(`/api/eshops/${eshopId}/test-product-loading`, { config });
};

export const analyzeLogin = (loginUrl, iterations = 1, htmlSize = 4000) => {
    return api.post('/api/login/analyze', {
        url: loginUrl,
        iterations,
        html_size: htmlSize
    });
};